























































































































































































import { Component, Vue } from "vue-property-decorator";
import { campaignsService } from "../api/campaigns.api";
import { ConfigurationModel } from "../models/Configuration";
import { MusicPlatformModel } from "../models/MusicPlatform";
import { MusicLinkModel } from "../models/Song";
import { appStore } from "../store/stores";

@Component
export default class CreateCampaign extends Vue {
  payload: any = {
    budget: 0
  };

  get genres(): any[] {
    return appStore.genres;
  }

  snippet!: File;

  get musicPlatforms(): MusicPlatformModel[] {
    return appStore.musicPlatforms;
  }

  musicLink: Partial<MusicLinkModel> = {};

  get configuration(): Partial<ConfigurationModel> {
    return appStore.configuration;
  }

  checkoutUrl?: string | null = null;

  isEdit = true;

  get noOfListeners() {
    return this.moneyFormat(
      ((this.configuration.listenBudgetPercentage! / 100) * this.payload.budget) / this.configuration.amountPerListen!
    );
  }

  get summary() {
    const vm = this;
    return {
      "Song title": this.payload.title,
      Genre: this.genres.find(x => x.id === this.payload.genreId)?.name,
      Snippet: this.snippet?.name,
      "Select Platform": this.musicPlatforms.find(x => x.id === this.payload.musicPlatformId)?.name,
      "Song Link": this.payload.link,
      Budget: vm.moneyFormat(vm.payload.budget),
      "No of Listeners": vm.noOfListeners
    };
  }

  async mounted() {}

  async handle(useWallet?: boolean) {
    try {
      await this.validate();
      this.showLoading();
      this.payload.musicLinks = [
        {
          musicPlatformId: this.musicLink.musicPlatformId,
          link: this.payload.link
        }
      ];

      const formData = new FormData();

      // song payload
      formData.append("title", this.payload.title);
      formData.append("genreId", this.payload.genreId);
      formData.append("snippet", this.snippet);
      formData.append("musicLinks", JSON.stringify(this.payload.musicLinks));

      // campaign payload
      formData.append("budget", this.payload.budget);
      formData.append("musicPlatformId", this.payload.musicPlatformId);

      if (useWallet) {
        formData.append("useWallet", "true");
      }

      const response = await campaignsService.createWithSong(formData);
      // this.toastSuccess(response.message);

      if (!useWallet) {
        this.checkoutUrl = response.data.metadata.authorization_url;
      }

      this.musicLink = {};
      this.payload = {
        budget: 0
      };
      const snipptRef: any = this.$refs.snippet;
      if (snipptRef) {
        snipptRef.value = null;
      }

      if (useWallet) {
        this.$router.push({ name: "ProfileScreen" });
      }
    } catch (error) {
      this.handleError(error);
    } finally {
      this.hideLoading();
    }
  }

  pay(url: string) {
    window.open(url, "_blank", "noreferrer");
    this.$router.push({ name: "ProfileScreen" });
  }

  handleMusicPlatformChange(Id: string) {
    const musicPlatform = this.musicPlatforms.find(x => x.id === Id);
    this.musicLink = {
      musicPlatformId: musicPlatform?.id,
      slug: musicPlatform?.slug
    };
  }

  uploadFile(file: File) {
    this.snippet = file;
  }

  async nextStep(value: boolean) {
    try {
      await this.validate();
      this.isEdit = value;
    } catch (error) {
      this.handleError(error);
    }
  }
}
